import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Alert,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import { AvForm, AvField } from "availity-reactstrap-validation";

import { Link, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import SubmitBloc from "./Blocs/SubmitBloc";
import { withRouter } from "react-router";
import moment from "moment";
// import Shimmer from "react-shimmer-effect";
import { ShimmerComponent } from "../../../../helpers/ui/ShimmerComponent";

// format dd/mm/yyy
var format_dmy = function (tgl) {
  return moment(tgl).format("DD-MM-YYYY");
};

class IndexView extends Component {
  submitBloc = new SubmitBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {
        emp_retired_sk_date: "",
        uuid: "",
        nip: "",
        nama: "",
        unit_kerja: "",
        jabatan: "",
        tmt_jabatan: "",
        tgl_pensiun: "",
        golongan: "",
        tgl_lahir: "",
        jenis_kelamin: "",
        tmt_pensiun: "",
        usia: "",
        usia_pensiun: "",
        sisa_masa_kerja: "",
        posisi: "",
      },
      submission_uuid: "",
      employeeItems: [],
      employeeSelected: "",
      failedInfoBmn: null,
      loadingDetail: false,
    };
  }

  submitData = async () => {
    if (this.state.dataForm.document.length > 0) {
      const files = ["document", "document_pertek"];
      let formData = generateFormData(this.state.dataForm, files);
      await this.submitBloc.fetchSubmit(formData);
    } else {
      await this.submitBloc.fetchSubmit(this.state.dataForm);
    }
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  // Cari apakah ada aset yang belum di kembalikan di aplikasi BMN
  getRequestAset = (uuid) => {
    const baseUrl = process.env.REACT_APP_SERVICE_BMN_URL;
    const appCode = process.env.REACT_APP_SERVICE_BMN_APPCODE;
    fetch(baseUrl + "/Integration/getRequestAset/json?uuid=" + uuid, {
      method: "GET",
      headers: {
        AppCode: appCode,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        return response.json(); // Convert response to JSON
      })
      .then((json) => {
        if (json.status) {
          if (typeof json.response === "string") {
            this.emptyInfo();
          } else if (typeof json.response === "object" && json.response.data) {
            // Check if the data array is empty
            this.emptyInfo();
            if (
              Array.isArray(json.response.data) &&
              json.response.data.length === 0
            ) {
              this.emptyInfo();
            } else {
              this.setState({
                failedBmn: true,
                failedInfoBmn:
                  "<b>" +
                  this.state.dataForm.nama +
                  "</b>, memiliki aset yang belum di kembalikan pada<b> Sistem Informasi Barang Milik Negara (BMN)</b> sebagai berikut :" +
                  this.formatAssets(json.response.data),
              });
            }
          } else {
            this.emptyInfo();
          }
        } else {
          this.emptyInfo();
        }
      })
      .catch((error) => {
        this.emptyInfo();
      });
  };

  emptyInfo = () => {
    this.setState({
      failedInfoBmn: "",
    });
  };

  formatAssets = (assets) => {
    return assets
      .map((asset, index) => {
        return `<br><b>${index + 1}. ${
          asset.asset_name ? asset.asset_name : "-"
        }</b>`;
      })
      .join(""); // tanpa koma
  };

  componentDidMount() {
    this.submitBloc.submitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.submitBloc.employeeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loadingDetail: true,
          });
          break;

        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              loadingDetail: false,
              dataForm: {
                uuid: response.retired_employee_uuid,
                nip: response.retired_employee_nip,
                nama: response.retired_employee_name,
                posisi: response.retired_employee_position_name,
                unit_kerja: response.retired_employee_work_unit_name,
                tgl_pensiun: format_dmy(response.retired_employee_retired_date),
                sisa_masa_kerja: response.employee_work_age,
              },
              submission_uuid: response.retired_employee_submission_uuid,
            });

            // cek peminjaman aset di BMN
            this.getRequestAset(response.retired_employee_uuid);
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    const queryParams = new URLSearchParams(window.location.search).get("uuid");
    this.submitBloc.fetchEmployee({ uuid: queryParams });
  }

  componentWillUnmount() {
    this.submitBloc.submitChannel?.unsubscribe();
    this.submitBloc.employeeChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>Verifikasi Usulan Pemberhentian</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <AvField
                      name="retired_employee_uuid"
                      type="hidden"
                      id="retired_employee_uuid"
                      value={this.state.dataForm.uuid}
                    />

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        NIP
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail ? (
                          <ShimmerComponent height={30} width="100%" />
                        ) : (
                          <AvField
                            placeholder=""
                            name="nip"
                            id="nip"
                            readonly="readOnly"
                            type="text"
                            className="form-control"
                            value={this.state.dataForm.nip}
                          />
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nama
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail ? (
                          <ShimmerComponent height={30} width="100%" />
                        ) : (
                          <AvField
                            placeholder=""
                            name="nama"
                            id="nama"
                            readonly="readOnly"
                            type="text"
                            className="form-control"
                            value={this.state.dataForm.nama}
                          />
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Posisi
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail ? (
                          <ShimmerComponent height={30} width="100%" />
                        ) : (
                          <AvField
                            placeholder=""
                            name="nama"
                            id="nama"
                            readonly="readOnly"
                            type="text"
                            className="form-control"
                            value={this.state.dataForm.posisi}
                          />
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Unit Kerja
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail ? (
                          <ShimmerComponent height={30} width="100%" />
                        ) : (
                          <AvField
                            placeholder=""
                            name="unit_kerja"
                            id="unit_kerja"
                            readonly="readOnly"
                            type="text"
                            className="form-control"
                            value={this.state.dataForm.unit_kerja}
                          />
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal Pemberhentian
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail ? (
                          <ShimmerComponent height={30} width="100%" />
                        ) : (
                          <AvField
                            placeholder=""
                            name="tgl_pensiun"
                            id="tgl_pensiun"
                            readonly="readOnly"
                            className="form-control"
                            value={this.state.dataForm.tgl_pensiun}
                          />
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Sisa Masa Kerja
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail ? (
                          <ShimmerComponent height={30} width="100%" />
                        ) : (
                          <AvField
                            placeholder=""
                            name="masa_kerja"
                            id="masa_kerja"
                            readonly="readOnly"
                            type="form-control"
                            className="form-control"
                            value={this.state.dataForm.sisa_masa_kerja}
                          />
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal SK <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail ? (
                          <ShimmerComponent height={30} width="100%" />
                        ) : (
                          <AvField
                            placeholder=""
                            name="emp_retired_sk_date"
                            id="emp_retired_sk_date"
                            type="date"
                            className="form-control"
                            value={this.state.dataForm.emp_retired_sk_date}
                          />
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        TMT Pemberhentian <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail ? (
                          <ShimmerComponent height={30} width="100%" />
                        ) : (
                          <AvField
                            placeholder="TMT Pemberhentian"
                            name="tmt_pensiun"
                            id="tmt_pensiun"
                            type="date"
                            className="form-control"
                            validate={{ required: { value: true } }}
                          />
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        No BKN <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail ? (
                          <ShimmerComponent height={30} width="100%" />
                        ) : (
                          <AvField
                            placeholder="Nomor BKN"
                            name="no_bkn"
                            id="no_bkn"
                            type="form-control"
                            className="form-control"
                            validate={{ required: { value: true } }}
                          />
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal BKN <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail ? (
                          <ShimmerComponent height={30} width="100%" />
                        ) : (
                          <AvField
                            placeholder="Tanggal BKN"
                            name="tgl_bkn"
                            id="tgl_bkn"
                            type="date"
                            className="form-control"
                            validate={{ required: { value: true } }}
                          />
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nomor SK Pemberhentian{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail ? (
                          <ShimmerComponent height={30} width="100%" />
                        ) : (
                          <AvField
                            placeholder="Nomor SK Pemberhentian"
                            name="no_sk_pensiun"
                            id="no_sk_pensiun"
                            type="form-control"
                            className="form-control"
                            validate={{ required: { value: true } }}
                          />
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        File SK Pemberhentian{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <FileInput name="document" />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        File Pertek BKNs <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <FileInput name="document_pertek" />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        {this.state.failedInfoBmn ? (
                          <Alert color="warning" role="alert">
                            <i className="uil-info-circle"></i> Informasi
                            Penting :
                            <div
                              dangerouslySetInnerHTML={{
                                __html: this.state.failedInfoBmn
                                  ? this.state.failedInfoBmn
                                  : "",
                              }}
                            />
                          </Alert>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link
                          to={`?pegawai&uuid=` + this.state.submission_uuid}
                        >
                          <Button color="warning">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-check"></i> Verifikasi
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan memverikasi data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil diverifikasi"
          failedTitle="Gagal!"
          failedInfo="Data gagal diverifikasi"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect
            to={
              `/kepegawaian/pensiun.html?pegawai&uuid=` +
              this.state.submission_uuid
            }
          />
        ) : null}
      </Fragment>
    );
  }
}

export default withRouter(IndexView);
